export const ARENA_LADDER_OPTIONS = Object.freeze([
  Object.freeze({ key: 'inter-spec', label: 'Inter-Spec' }),
  Object.freeze({ key: '2v2', label: '2v2' }),
  Object.freeze({ key: '4v4', label: '4v4' }),
  Object.freeze({ key: '8v8', label: '8v8' }),
]);

export function findArenaLadder(ladders, key) {
  const ladder = Array.isArray(ladders)
    ? ladders.find(candidate => candidate?.key === key)
    : null;
  const definition = ARENA_LADDER_OPTIONS.find(candidate => candidate.key === key)
    || ARENA_LADDER_OPTIONS[0];

  return ladder || { ...definition, entries: [] };
}

export function filterArenaEntries(entries, search) {
  const term = String(search || '').trim().toLocaleLowerCase();
  if (!term) return Array.isArray(entries) ? entries : [];

  return (Array.isArray(entries) ? entries : []).filter(entry => (
    [entry?.playerName, entry?.className, entry?.clan, entry?.rankTitle]
      .some(value => String(value || '').toLocaleLowerCase().includes(term))
  ));
}
